<template>
  <div class="filters-card">
    <div class="card-header">
      <h3 class="text-lg font-semibold text-gray-800">
        <i class="fas fa-filter mr-2"></i>Filtres de recherche
      </h3>
      <button @click="toggleFilters" class="toggle-btn">
        <i :class="showFilters ? 'fas fa-chevron-up' : 'fas fa-chevron-down'"></i>
      </button>
    </div>

    <div v-show="showFilters" class="card-body">
      <!-- Première ligne -->
      <div class="filter-row">
        <div class="filter-group">
          <label class="filter-label">
            <i class="fas fa-search mr-1"></i>Recherche globale
          </label>
          <input
            v-model="localFilters.search"
            type="text"
            placeholder="Rechercher dans les logs..."
            class="filter-input"
            @keyup.enter="applyFilters"
          />
        </div>

        <div class="filter-group">
          <label class="filter-label">
            <i class="fas fa-link mr-1"></i>Endpoint
          </label>
          <input
            v-model="localFilters.endpoint"
            type="text"
            placeholder="Ex: /api/comptes"
            class="filter-input"
            @keyup.enter="applyFilters"
          />
        </div>

        <div class="filter-group">
          <label class="filter-label">
            <i class="fas fa-user mr-1"></i>ID Utilisateur
          </label>
          <input
            v-model="localFilters.userId"
            type="text"
            placeholder="Ex: recrOP6fReqP5s3Jv"
            class="filter-input"
            @keyup.enter="applyFilters"
          />
        </div>
      </div>

      <!-- Deuxième ligne -->
      <div class="filter-row">
        <div class="filter-group">
          <label class="filter-label">
            <i class="fas fa-info-circle mr-1"></i>Statut
          </label>
          <select v-model="localFilters.status" class="filter-select">
            <option value="">Tous</option>
            <option value="success">Succès</option>
            <option value="failure">Échec</option>
          </select>
        </div>

        <div class="filter-group">
          <label class="filter-label">
            <i class="fas fa-code mr-1"></i>Code HTTP
          </label>
          <select v-model="localFilters.statusCode" class="filter-select">
            <option value="">Tous</option>
            <option value="200">200 - OK</option>
            <option value="201">201 - Created</option>
            <option value="400">400 - Bad Request</option>
            <option value="401">401 - Unauthorized</option>
            <option value="404">404 - Not Found</option>
            <option value="500">500 - Server Error</option>
          </select>
        </div>

        <div class="filter-group">
          <label class="filter-label">
            <i class="fas fa-sort mr-1"></i>Trier par
          </label>
          <select v-model="localFilters.sortBy" class="filter-select">
            <option value="created_at">Date de création</option>
            <option value="status_code">Code HTTP</option>
            <option value="response_time_ms">Temps de réponse</option>
            <option value="status">Statut</option>
          </select>
        </div>

        <div class="filter-group">
          <label class="filter-label">
            <i class="fas fa-arrows-alt-v mr-1"></i>Ordre
          </label>
          <select v-model="localFilters.sortOrder" class="filter-select">
            <option value="DESC">Décroissant</option>
            <option value="ASC">Croissant</option>
          </select>
        </div>
      </div>

      <!-- Troisième ligne -->
      <div class="filter-row">
        <div class="filter-group">
          <label class="filter-label">
            <i class="fas fa-calendar mr-1"></i>Date de début
          </label>
          <input
            v-model="localFilters.dateFrom"
            type="date"
            class="filter-input"
          />
        </div>

        <div class="filter-group">
          <label class="filter-label">
            <i class="fas fa-calendar mr-1"></i>Date de fin
          </label>
          <input
            v-model="localFilters.dateTo"
            type="date"
            class="filter-input"
          />
        </div>

        <div class="filter-group">
          <label class="filter-label">
            <i class="fas fa-list-ol mr-1"></i>Résultats par page
          </label>
          <select v-model.number="localFilters.limit" class="filter-select">
            <option :value="50">50</option>
            <option :value="100">100</option>
            <option :value="200">200</option>
            <option :value="500">500</option>
          </select>
        </div>
      </div>

      <!-- Boutons d'action -->
      <div class="action-buttons">
        <button @click="applyFilters" class="btn btn-primary">
          <i class="fas fa-search mr-2"></i>Rechercher
        </button>
        <button @click="resetFilters" class="btn btn-secondary">
          <i class="fas fa-redo mr-2"></i>Réinitialiser
        </button>
        <button @click="exportData" class="btn btn-success">
          <i class="fas fa-download mr-2"></i>Exporter CSV
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LogsFilters',
  props: {
    filters: {
      type: Object,
      required: true,
    },
  },
  emits: ['update:filters', 'search', 'reset', 'export'],
  data() {
    return {
      showFilters: true,
      localFilters: {
        page: 1,
        limit: 100,
        status: '',
        statusCode: '',
        userId: '',
        endpoint: '',
        search: '',
        dateFrom: '',
        dateTo: '',
        sortBy: 'created_at',
        sortOrder: 'DESC',
      },
    };
  },
  mounted() {
    // Initialiser localFilters avec les props une fois le composant monté
    this.localFilters = { ...this.filters };
  },
  watch: {
    filters: {
      handler(newVal) {
        this.localFilters = { ...newVal };
      },
      deep: true,
    },
  },
  methods: {
    toggleFilters() {
      this.showFilters = !this.showFilters;
    },
    applyFilters() {
      this.localFilters.page = 1; // Reset à la page 1
      this.$emit('update:filters', this.localFilters);
      this.$emit('search');
    },
    resetFilters() {
      this.$emit('reset');
    },
    exportData() {
      this.$emit('export');
    },
  },
};
</script>

<style scoped>
.filters-card {
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  margin-bottom: 1.5rem;
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1.25rem;
  border-bottom: 1px solid #e5e7eb;
}

.toggle-btn {
  background: none;
  border: none;
  color: #6b7280;
  cursor: pointer;
  font-size: 1rem;
  transition: color 0.2s;
}

.toggle-btn:hover {
  color: #16a34a;
}

.card-body {
  padding: 1.25rem;
}

.filter-row {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 1rem;
  margin-bottom: 1rem;
}

.filter-group {
  display: flex;
  flex-direction: column;
}

.filter-label {
  font-size: 0.875rem;
  font-weight: 500;
  color: #374151;
  margin-bottom: 0.5rem;
}

.filter-input,
.filter-select {
  padding: 0.5rem 0.75rem;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  font-size: 0.875rem;
  transition: all 0.2s;
}

.filter-input:focus,
.filter-select:focus {
  outline: none;
  border-color: #16a34a;
  box-shadow: 0 0 0 3px rgba(22, 163, 74, 0.1);
}

.action-buttons {
  display: flex;
  gap: 0.75rem;
  margin-top: 1.5rem;
  flex-wrap: wrap;
}

.btn {
  padding: 0.625rem 1.25rem;
  border-radius: 6px;
  font-weight: 500;
  font-size: 0.875rem;
  cursor: pointer;
  transition: all 0.2s;
  border: none;
  display: inline-flex;
  align-items: center;
}

.btn-primary {
  background-color: #16a34a;
  color: white;
}

.btn-primary:hover {
  background-color: #15803d;
}

.btn-secondary {
  background-color: #6b7280;
  color: white;
}

.btn-secondary:hover {
  background-color: #4b5563;
}

.btn-success {
  background-color: #2563eb;
  color: white;
}

.btn-success:hover {
  background-color: #1d4ed8;
}
</style>

